<template>
  <div class="pb-3">
    <ul class="sort-list main-list">
      <AdvancedSort />
      <NormalSort />
      <SortPopup :is-load="isLoad" :condition="condition" />
    </ul>
  </div>
</template>

<script>
import SortPopup from '@page/shop/components/SortPopup.vue';
import AdvancedSort from '@page/shop/components/AdvancedSort.vue';
import NormalSort from '@page/shop/components/NormalSort.vue';

export default {
  components: { SortPopup, AdvancedSort, NormalSort },
  props: {
    condition: {
      type: Object,
      required: true,
    },
    isLoad: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
